module.exports = __webpack_public_path__ + "img/fgr.2b6537b1.jpg";